export const WIDGET_TYPES = {
  TEXT_SECTION: 'text_section_widget',
  LIST_LINE: 'list_line_widget',
  LIST_LINE_RAW: 'list_line_raw_action_widget',
  INFO_LINE_ACTION: 'info_line_action_widget',
} as const;
